module.exports = __webpack_public_path__ + "static/about-us-4dedfefa13430f943317e1af95fd2c30.svg";